import { renewEnrollmentService } from '../services'

const renewEnrollmentValidatorService = {
  checkHasRenewEnrollment: async (groupStudentId) => {
    const { success, payload } = await renewEnrollmentService.checkEligibility(groupStudentId)
    if (!success) throw new Error('Erro ao validar dados. Tente novamente.')

    const { hasRenewEnrollment } = payload
    if (hasRenewEnrollment) {
      throw new Error('Foi identificada uma rematrícula para o CPF informado.')
    }
  },

  checkHasSubscription: async (groupStudentId) => {
    const { success, payload } = await renewEnrollmentService.checkEligibility(groupStudentId)
    if (!success) throw new Error('Erro ao validar dados. Tente novamente.')

    const { hasSubscription, subscriptionProtocol } = payload
    if (hasSubscription) {
      const error = new Error('Foi identificada uma inscrição para o CPF informado.')
      error.subscriptionProtocol = subscriptionProtocol || null
      throw error
    }
  },
}

export default renewEnrollmentValidatorService
